import { useCallback } from 'react';
import {
  useGetNotificationQuery,
  useGetUnReadMessageCountQuery,
  useMarkAsReadMutation,
} from '@viome/viome-base/src/usecase/Notification/NotificationQuery';

export const useNotificationViewModel = (open: boolean) => {
  const {
    data: notificationsData,
    isLoading: isLoadingNotifications,
    refetch: refetchNotifications,
    isError: isErrorNotifications,
  } = useGetNotificationQuery({ enabled: open });

  const { data: unreadCountData, refetch: refetchUnreadCount } =
    useGetUnReadMessageCountQuery();

  const { mutateAsync: markAsRead } = useMarkAsReadMutation();

  const handleRefreshUnreadCount = async (): Promise<void> => {
    await refetchUnreadCount();
  };

  const handleRefresh = async (): Promise<void> => {
    if (open) {
      await refetchNotifications();
    } else {
      await refetchUnreadCount();
    }
  };

  const handleMarkAsRead = useCallback(
    async (notificationId: string): Promise<void> => {
      await markAsRead({ messageId: notificationId });
    },
    [markAsRead],
  );

  const unreadCount: number = unreadCountData?.count ?? 0;

  return {
    // State
    notificationsData,
    unreadCount,

    // Loading
    isLoadingNotifications,
    isErrorNotifications,

    // Actions
    handleMarkAsRead,
    handleRefresh,
    handleRefreshUnreadCount,
  };
};
